import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { FIELD_OPS_PERMISSIONS } from '@/constants/permissions';
import { z } from 'zod';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveysListPage } from '@/features/surveys/pages/SurveysListPage';
import { SURVEY_STATUS } from '@/features/surveys/types/survey.types';

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export const surveysListSearchSchema = z.object({
  q: z.string().optional(),
  state: z.enum(SURVEY_STATUS).optional(),
  from: z.string().regex(DATE_ONLY_RE).optional(),
  to: z.string().regex(DATE_ONLY_RE).optional(),
});

export type SurveysListSearch = z.infer<typeof surveysListSearchSchema>;

export const Route = createFileRoute('/_auth/feedback/surveys/')({
  beforeLoad: () => requirePermission(FIELD_OPS_PERMISSIONS.SURVEY_VIEW),
  validateSearch: surveysListSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Surveys">
      <Suspense fallback={<PageLoader />}>
        <SurveysListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
